import React, { useState, useEffect } from 'react'
import { Card, Input, Button, Table, Select, Tag, message, Typography, Popconfirm } from 'antd'
import { NotificationOutlined, SendOutlined } from '@ant-design/icons'
import { backend } from '../../api'

const { Title, Text } = Typography
const { TextArea } = Input

const TARGET_OPTIONS = [
  { value: 'all', label: '全部用户' },
  { value: 'admin', label: '仅管理员' }
]
const TARGET_COLORS = { all: 'blue', admin: 'orange' }
const TARGET_NAMES = { all: '全部用户', admin: '仅管理员' }

export default function AnnouncementPush() {
  const [announcements, setAnnouncements] = useState([])
  const [loading, setLoading] = useState(false)
  const [publishing, setPublishing] = useState(false)

  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const [target, setTarget] = useState('all')

  const fetchAnnouncements = async () => {
    setLoading(true)
    try {
      const res = await backend.getAnnouncements()
      if (res.announcements) {
        setAnnouncements(res.announcements)
      } else if (Array.isArray(res)) {
        setAnnouncements(res)
      } else {
        setAnnouncements([])
      }
    } catch (err) {
      message.error('获取公告列表失败: ' + (err.message || '未知错误'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { fetchAnnouncements() }, [])

  const handlePublish = async () => {
    if (!title.trim()) { message.warning('请输入公告标题'); return }
    if (!content.trim()) { message.warning('请输入公告内容'); return }
    setPublishing(true)
    try {
      const res = await backend.adminCreateAnnouncement({ title: title.trim(), content: content.trim(), target })
      if (res.success) {
        message.success('公告发布成功')
        setTitle('')
        setContent('')
        setTarget('all')
        fetchAnnouncements()
      } else {
        message.error(res.message || '发布失败')
      }
    } catch (err) {
      message.error('发布失败: ' + (err.message || '未知错误'))
    } finally {
      setPublishing(false)
    }
  }

  const handleDelete = async (record) => {
    try {
      const res = await backend.adminDeleteAnnouncement(record.id || record.announcement_id)
      if (res.success) {
        message.success('公告已删除')
        fetchAnnouncements()
      } else {
        message.error(res.message || '删除失败')
      }
    } catch (err) {
      message.error('删除失败: ' + (err.message || '未知错误'))
    }
  }

  const columns = [
    {
      title: '标题', dataIndex: 'title', key: 'title', width: 200,
      ellipsis: true
    },
    {
      title: '目标', dataIndex: 'target', key: 'target', width: 100,
      render: v => <Tag color={TARGET_COLORS[v] || 'default'}>{TARGET_NAMES[v] || v}</Tag>
    },
    {
      title: '发布时间', dataIndex: 'created_at', key: 'created_at', width: 160,
      render: v => v ? new Date(v).toLocaleString() : '-'
    },
    {
      title: '操作', key: 'actions', width: 80, fixed: 'right',
      render: (_, record) => (
        <Popconfirm
          title="确认删除"
          description="确定要删除此公告吗？"
          onConfirm={() => handleDelete(record)}
          okText="删除"
          cancelText="取消"
          okType="danger"
        >
          <Button type="link" danger>删除</Button>
        </Popconfirm>
      )
    }
  ]

  return (
    <div>
      <Title level={4}><NotificationOutlined /> 公告推送</Title>

      <Card title="发布公告" style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 12 }}>
          <Text style={{ fontSize: 13 }}>标题</Text>
          <Input
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder="请输入公告标题"
            maxLength={100}
            style={{ marginTop: 4 }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <Text style={{ fontSize: 13 }}>内容</Text>
          <TextArea
            value={content}
            onChange={e => setContent(e.target.value)}
            placeholder="请输入公告内容"
            rows={4}
            maxLength={2000}
            showCount
            style={{ marginTop: 4 }}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <Text style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>目标用户</Text>
          <Select value={target} onChange={setTarget} options={TARGET_OPTIONS} style={{ width: 160 }} />
        </div>
        <Button type="primary" icon={<SendOutlined />} loading={publishing} onClick={handlePublish}>
          发布公告
        </Button>
      </Card>

      <Card title="公告列表">
        <Table
          rowKey={r => r.id || r.announcement_id}
          columns={columns}
          dataSource={announcements}
          loading={loading}
          scroll={{ x: 600 }}
          pagination={{ pageSize: 20, showSizeChanger: true, showTotal: t => `共 ${t} 条` }}
        />
      </Card>
    </div>
  )
}
